import React from "react";
import { GlobalRoutes } from "./auto-routes";
import "./styles/App.less";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import enUS from "antd/es/locale/en_US";
import jaJP from "antd/es/locale/ja_JP";
import koKR from "antd/es/locale/ko_KR";
import plPL from "antd/es/locale/pl_PL";
import zhTW from "antd/es/locale/zh_TW";
import "moment/locale/zh-cn";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/pl";
import "moment/locale/zh-tw";
import "moment/locale/en-gb";
import { StandardLocale } from "./gs-utils/core/storage/LocaleManager";
import { Locale } from "antd/es/locale-provider";

const { name } = require("../package.json");

function getLocalLanguage(localLang: string) {
  const antdLocale: Record<string, Locale> = {
    [StandardLocale.ZH_CN]: zhCN,
    [StandardLocale.EN_US]: enUS,
    [StandardLocale.KO_KR]: koKR,
    [StandardLocale.JA_JP]: jaJP,
    [StandardLocale.PL_PL]: plPL,
    [StandardLocale.ZH_TW]: zhTW,
  };

  return antdLocale[localLang] || enUS;
}

function App() {
  ConfigProvider.config({
    prefixCls: name,
  });
  const language = localStorage.getItem("locale") || StandardLocale.EN_US;
  return (
    <ConfigProvider locale={getLocalLanguage(language)} prefixCls={name}>
      <div className="App">
        <GlobalRoutes />
      </div>
    </ConfigProvider>
  );
}

export default App;
